import { createDataWidget } from "@/widgets/common/createDataWidget";
import { applyChartSort } from "@/widgets/common/chartSort";
import { mockFetch } from "@/widgets/common/mockFetch";
import { generateOeeSeries } from "./mock";
import type { OeeFetchParams, OeePoint } from "./types";

/**
 * Widget state via the shared factory (D11): thunk + slice + selectors in one
 * declaration — replaces the hand-written `thunks.ts`/`slice.ts`/`selectors.ts`
 * trio. Swapping in CubeJS replaces `mockFetch` with a real fetcher.
 *
 * Sorting is server-side (the chart pages through a large series — FR-A5):
 * the mock fetcher applies the sort AFTER grouping, exactly where a real
 * CubeJS `order` would act.
 */
export const oeeTrendChart = createDataWidget<OeePoint, OeeFetchParams>({
  name: "oeeTrendChart",
  fetcher: mockFetch(({ group = "day", sort }) =>
    // ISO `yyyy-MM-dd` labels: string order is already chronological.
    applyChartSort(generateOeeSeries(group), sort),
  ),
});
